export const NOSLA_VALUE = 'NOSLA';
export const NOSLA_LABEL = 'NO SLA';

export const DEFAULT_SUBSCRIPTION_TYPES = [
    { type: 'Silver' },
    { type: 'Gold' },
    { type: 'Platinum' },
];

export const DEFAULT_LABELS = {
    customerAccount:        'Customer Account',
    typeOfSubscription:     'Type of Subscription',
    country:                'Country',
    customerEmailAddresses: 'Customer Email Addresses',
    siteIds:                'Site IDs',
};

export const DEFAULT_PLACEHOLDERS = {
    customerAccount:        'Select account',
    typeOfSubscription:     'Select subscription',
    country:                'Select country',
    customerEmailAddresses: 'Select email addresses',
    siteIds:                'Select site ids',
};

export const DEFAULT_BUTTON_LABELS = {
    confirm: 'Add',
    cancel:  'Cancel',
};

export const DEFAULT_MESSAGES = {
    requiredError:          'This is a mandatory field',
    selectCustomerFirst:    'Select a customer account first',
    noUsersAssigned:        'No users are assigned to the customer, please assign user to proceed',
    noSitesAssigned:        'No sites are assigned to the customer, please assign site to proceed',
    loadInitialError:       'Failed to load initial data. Please refresh and try again.',
    loadCustomerDataError:  'Failed to load customer data. Please try again.',
    loadEditError:          'Failed to load subscription details. Please try again.',
    submitSuccess:          'Subscription added successfully.',
    submitError:            'Failed to add subscription. Please try again.',
    submitUpdateSuccess:    'Subscription updated successfully.',
    submitUpdateError:      'Failed to update subscription. Please try again.',
};

export const DEFAULT_CANCEL_DIALOG = {
    message:  'Are you sure you want to exit?',
    subtext:  'Your changes will not be saved.',
    yesLabel: 'Yes',
    noLabel:  'No',
};

import type { CopSubscriptionConfig } from './CopSubscription.config';

export function getSubmitSuccessMsg(isEdit: boolean, config: CopSubscriptionConfig): string {
    const desc = config.confirmation?.successDescription;
    return desc ?? (isEdit ? DEFAULT_MESSAGES.submitUpdateSuccess : DEFAULT_MESSAGES.submitSuccess);
}

export function getSubmitErrorMsg(isEdit: boolean, config: CopSubscriptionConfig): string {
    const desc = config.confirmation?.errorDescription;
    return desc ?? (isEdit ? DEFAULT_MESSAGES.submitUpdateError : DEFAULT_MESSAGES.submitError);
}
